import React, { useEffect, useState } from "react";
import { studentClassSection } from "../../../Store/api/activities";
import { useDispatch } from "react-redux";
export const SubjectSetting = () => {
  const dispatch = useDispatch();
  const [activitySetting, setActivitySetting] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    dispatch(
      studentClassSection({
        onSuccess: (res) => {
          setActivitySetting(res.data.data);
          setLoading(false);
        },
        onError: (err) => {
          setLoading(false);
        },
      })
    );
  }, []);
  return (
    <>
      {loading ? (
        <>Loading...</>
      ) : (
        <>
          {activitySetting.map((setting, index) => {
            const staticInfo = setting.classes.activitySettings;

            return (
              <div className="box_border_settings border-grey" key={index}>
                <div className="settings_header">
                  <h2>{setting.classes.courseName} activity settings</h2>
                </div>
                <div
                  className="setting_rows"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Allow feedback from students
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.allowStdFeedback ? "Yes" : "No"}
                  </p>
                </div>
                <div
                  className="setting_rows"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Allow multiple attempts
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.multipleAttempts.count}
                  </p>
                </div>
                <div
                  className="setting_rows"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Drop lowest grade per chapter{" "}
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.dropLowestGrade.percentage}
                  </p>
                </div>
                <div
                  className="setting_rows"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Can submit past due date{" "}
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.isPastDueAllowed ? "Yes" : "No"}
                  </p>
                </div>
                <div
                  className="setting_rows"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Past due date penalty{" "}
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.pastDuePenalty.percentage}% per day
                  </p>
                </div>
                <div
                  className="setting_rows"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Special characters provided{" "}
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.spacialChars}
                  </p>
                </div>
                <div
                  className="setting_rows"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Auto-grade accounts for accent marks
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.autoGradeAccent ? "Yes" : "No"}
                  </p>
                </div>
                <div
                  className="setting_rows"
                  style={{
                    justifyContent: "space-between",
                    marginBottom: "12px",
                  }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Auto-grade accounts for capitalization{" "}
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.autoGradeCapitalization ? "Yes" : "No"}
                  </p>
                </div>
                <div
                  className="setting_rows mb-0"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="key" style={{ width: "60%" }}>
                    Auto-grade accounts for punctuation{" "}
                  </p>
                  <p style={{ width: "10%" }}></p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {staticInfo.autoGradePunctuation ? "Yes" : "No"}
                  </p>
                </div>
              </div>
            );
          })}
        </>
      )}
    </>
  );
};
